import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/Sidebar';
import Header from '@/components/Header';
import AIAssistant from '@/components/AIAssistant';
import AcceptTermsGate from '@/components/AcceptTermsGate';

const API = process.env.REACT_APP_BACKEND_URL;

const MainLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [needsAccept, setNeedsAccept] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API}/api/auth/me`, { credentials: 'include' });
        if (r.ok) {
          const u = await r.json();
          if (!u.terms_accepted_at) setNeedsAccept(true);
        }
      } catch { /* silent */ }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#020617] flex">
      {mobileOpen && (
        <div className="fixed inset-0 bg-black/60 z-40 lg:hidden" onClick={() => setMobileOpen(false)} />
      )}
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} collapsed={collapsed} />
      <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${collapsed ? 'lg:ml-[68px]' : 'lg:ml-64'}`}>
        <Header onMenuToggle={() => setMobileOpen(!mobileOpen)} onCollapseToggle={() => setCollapsed(!collapsed)} collapsed={collapsed} />
        <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-auto">
          <Outlet />
        </main>
      </div>
      <AIAssistant />
      <AcceptTermsGate open={needsAccept} onAccepted={() => setNeedsAccept(false)} />
    </div>
  );
};

export default MainLayout;
